import { HttpClient, HttpParams,  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, forkJoin, mergeMap, of, pipe, switchMap, tap, throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { REQUESTS_BASE_URL } from 'src/environments/environment';
import { NewsViewModel } from '../shared/viewModels/news.viewModel';
import { GUID } from '../shared/helpers';
import { RadioCardViewModel } from '../shared/ui-kit/webiat-radio-card/webiad-radio-card.viewModel';

@Injectable({
  providedIn: 'root',
})
export class CardCreatorService {
  public initialRadioButtons: RadioCardViewModel[] = [
    {
      value: 'image',
      ActiveIcon: 'imageIcon',
      disabledIcon: 'imageIconDisabled',
      title: 'Images',
      description: 'Ici vous pouvez télécharger jusqu’à 20 images',
      disabled: false,
    },
    {
      value: 'video',
      ActiveIcon: 'videoIcon',
      disabledIcon: 'videoIconDisabled',
      title: 'Vidéo',
      description: 'Ici vous pouvez télécharger une vidéo',
      disabled: false,
    },
    {
      value: 'doc',
      ActiveIcon: 'fileIcon',
      disabledIcon: 'fileIconDisabled',
      title: 'Documents',
      description:
        'ici vous pouvez télécharger jusqu’au deux documents ( de type PDF et/ou Word )',
      disabled: false,
    },
  ];
  constructor(
    private http: HttpClient,
      ) { }

  public getCategoryList(): Observable<any> {
    return this.http.get<any>(
      `${REQUESTS_BASE_URL}/api/home/client-api/category/all`);
  }


  updateNews(newsData: any , newsId : string): Observable<any> {
    return this.uploadMediaFiles(newsData.mediaList, newsData.documentList, newsId).pipe(
      mergeMap(() => {
        return this.http
          .put<any>(
            `${REQUESTS_BASE_URL}/api/home/client-api/update-news`,
            {
              id: newsId,
              title: newsData.title,
              description: newsData.description,
              coverPicture: newsData.mediaList[0] ? 'Generic/home/' + newsData.mediaList[0]?.file.name : null,
              postingStartDate: newsData.postingStartDate,
              postingEndDate: newsData.postingEndDate,
              eventDate: newsData.postingStartDate,
              interaction: newsData.interaction,
              category: newsData.category,
              interactionsList: newsData.interactionsList,
              documentList: newsData.documentList.map((doc : any) => ({
                name: doc.file.name,
                code: doc.code,
                priority: doc.priority,
              })),
              mediaList: newsData.mediaList.map((media: any) => ({
                name: media.file.name,
                code: media.code,
                type: media.mediaType,
              })),
              enableComment : newsData.enableComment,
              boostComment: newsData.boostComment,
              showComment: newsData.showComment
            }
          )
          .pipe(
            catchError((error) => {
              console.error('News update error:', error);
              return throwError(() => error);
            })
          );
      })
    );
  }

  private uploadMediaFiles(mediaList: any[], documentList: any[], newsId: string): Observable<any[]> {
    const uploadObservables: Observable<any>[] = [];

    mediaList?.forEach((media: any) => {
        uploadObservables.push(this.uploadFileToNews(media.file, newsId, media.file.name));
    });

    documentList?.forEach((doc: any) => {
        uploadObservables.push(this.uploadFileToNews(doc.file, newsId, doc.file.name));
    });

    return uploadObservables.length ? forkJoin(uploadObservables) : of([]);
  }

  private uploadFileToNews(file: File, newsId: string, blobName: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('blobName', blobName); 
      
    return this.http.post(`${REQUESTS_BASE_URL}/api/file-manager/client-api/v2/new-asset/${newsId}/${blobName}`, formData)
        .pipe(
            catchError((error) => {
                console.error('File upload error:', error);
                return throwError(() => error);
            })
        );
  }

  public persistNews(newsData: NewsViewModel): Observable<any> {
    let newsId : any 
    newsData.mediaList.forEach((media: any) => {
      media.code = GUID.newGUID();
    });
    newsData.documentList.forEach((doc: any, index: number) => {
        doc.code = GUID.newGUID();
        doc.priority = index + 1;
    });

        return this.http
          .post<any>(
            `${REQUESTS_BASE_URL}/api/home/client-api/create-news`,
            {
              title: newsData.title,
              description: newsData.description,
              coverPicture: newsData.mediaList[0] ? newsData.mediaList[0]?.file.name : null,
              postingStartDate: newsData.postingStartDate,
              postingEndDate: newsData.postingEndDate,
              eventDate: newsData.postingStartDate,
              createdAt: newsData.createdAt,
              assignment: null,
              adviserId: null,
              interaction: newsData.interaction,
              category: newsData.category,

              documentList: newsData.documentList.map((doc) => ({
                name: doc.file.name,
                code: doc.code,
                priority: doc.priority,
              })),
              mediaList: newsData.mediaList.map((media) => ({
                name: media.file.name,
                code: media.code,
                type: media.mediaType,
              })),
              interactionsList: newsData.interactionsList,
              enableComment : newsData.enableComment,
              boostComment: newsData.boostComment,
              showComment: newsData.showComment
            })
          .pipe(
            mergeMap((response: any) => {
              newsId = response.id
              return this.uploadMediaFiles(newsData.mediaList, newsData.documentList, newsId);
            }),
          
            catchError((error ) => {
              console.error('News creation error:', error);
              return this.http.delete<any>(`${REQUESTS_BASE_URL}/api/home/client-api/deleteNewsWeb/${newsId}`,
                  {observe: 'response'}).pipe(
                    mergeMap(()=>{
                      return throwError(()=> error);
                    })
                  )
      })
    );
  }

  getCardInfoById(id : any ){
    return this.http
    .get<any>(
      `${REQUESTS_BASE_URL}/api/home/client-api/news/${id}`,
    )
  }

  getResourceByLink(path : string){
    return this.http.get(`${REQUESTS_BASE_URL}/api/file-manager/client-api/v2/fileWithLinkNew`, {
      responseType: 'blob',
      params: new HttpParams().set('link', path)
    });
  }
}
